import updateSettings from './update-settings';

const initSettingsForFirstLoading = (
  settings,
  updateGlobals = true,
  updateCopyrightGlobal = false
) => updateSettings(settings, updateGlobals, updateCopyrightGlobal, { firstInitiation: true });

export default initSettingsForFirstLoading;
